import cn from "classnames"

import { Flex, Text } from "@/atoms"
import { useNumberConvertor } from "@/hooks/useNumberConvertor"

import styles from "./LegendChart.module.scss"

import type { LegendChartProps } from "./LegendChart.types"

export const LegendChart = (props: LegendChartProps) => {
  const { items, vertical, gap = 4 } = props
  const { abbreviateNumber } = useNumberConvertor()

  return (
    <Flex
      vertical={vertical}
      gap={gap}
      className={cn(styles.container, { [styles.containerVertical]: vertical })}
    >
      {items.map(({ color, label, value }) => (
        <Flex key={label} align="center" justify="space-between">
          <Flex align="center" gap={8}>
            <span
              className={styles.marker}
              style={{ backgroundColor: color }}
            />
            <Text className={cn("sm-text-ks", styles.label)} type="secondary">
              {label}
            </Text>
          </Flex>
          <Text className={styles.value}>
            {typeof value === "number" && abbreviateNumber(value)}
            {typeof value === "string" && value}
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}
